<!-- <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="dialogRef.close(false)">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button> -->

<h1 mat-dialog-title class="editHeader text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="mt-3">
    <!-- <div class="col-md-12 mb-1">
      <label class="payingClinic col-md-6">Clinic Names: </label>
      <label class="payingClinic col-md-6">
        <ng-container *ngFor="let item of subscriptionData.clinics;let last=last;">{{item?.clinic?.name}}<span
            *ngIf="!index">,</span></ng-container>
      </label>
    </div> -->
    <div class="col-md-12 mb-1">
      <label for="firstName" class="payingClinic col-md-6 text-bold">Doctor: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.doctor?.first_name}}
        {{subscriptionData?.doctor?.last_name}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="mobileNumber" class="payingClinic col-md-6 text-bold">Active / Max Doctor: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.active_doctors}} /
        {{subscriptionData?.max_doctors}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="lastName" class="payingClinic col-md-6 text-bold">Plan: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.plan?.name}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="keySkills" class="payingClinic col-md-6 text-bold">Paid Amount: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.paid_amount}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="keySkills" class="payingClinic col-md-6 text-bold">Trail Period Start: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.trail_period_start | date:'dd-MM-yyyy'}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="keySkills" class="payingClinic col-md-6 text-bold">Trail Period End: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.trail_period_end | date:'dd-MM-yyyy'}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="keySkills" class="payingClinic col-md-6 text-bold">Subscription Start: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.subscription_start | date:'dd-MM-yyyy'}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="keySkills" class="payingClinic col-md-6 text-bold">Subscription End: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.subscription_end | date:'dd-MM-yyyy'}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="keySkills" class="payingClinic col-md-6 text-bold">Subscription Extented: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.subscription_extented | date:'dd-MM-yyyy'}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="qualification" class="payingClinic col-md-6 text-bold">Status: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.status}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label for="qualification" class="payingClinic col-md-6 text-bold">Status Change: </label>
      <label class="payingClinic col-md-6">{{subscriptionData?.status_change}}</label>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="ml-4">
    <button mat-button class="mat-raised-button mr-4  btnWidth btn blankTurquoise"
      (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button mr-4 btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="activateSubscription()" [disabled]="deactivated">Activate</button>
    <button mat-button class="mat-raised-button btn rejectBtn btnWidth btn-sm updateButton"
      (click)="deactivateSubscription()" [disabled]="activated">Deactivate</button>
  </div>
</mat-dialog-actions>
